import React from 'react';

import { VerticalBarChart } from '../../barChart';

export const barChartRenderer = (item, { series = [], labels = {} }, showChart) => {
  if (!showChart) {
    return null;
  }

  const AXIS = 'key';
  const VALUE = 'value';

  const chartData = series.map((serie) => ({
    [AXIS]: labels[serie],
    [VALUE]: item[serie],
  }));

  const width = 40 + series.length * 25;

  const data = {
    series: [VALUE],
    axis: AXIS,
    data: chartData,
  };

  const config = {
    legendVisibility: false,
    titlesVisibility: false,
    groupPadding: 0.3,
    yAxisSpace: 20,
  };

  return <VerticalBarChart width={width} height={120} data={data} config={config} showTooltip={false} />;
};
